export default {
  arquivoSelecionado: null,
  nomeArquivoSelecionado: null,
  workbookData: null,
  resultSet: null,
  step: 0,
  readingFile: false,
  sendingFile: false
}
